"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PagingGrid = exports.Grid = exports.QueryResults = exports.Memory = exports.domConstruct = exports.Deferred = void 0;
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./__package__"), exports);
//  dojo  ---
// import "dojo/has!webpack?dojo-webpack-plugin/amd/dojoES6Promise";
var declare = require("dojo/_base/declare");
var _Deferred = require("dojo/Deferred");
var _domConstruct = require("dojo/dom-construct");
exports.Deferred = _Deferred;
exports.domConstruct = _domConstruct;
//  dstore  ---
var _Memory = require("dojo-dstore/Memory");
var _QueryResults = require("dojo-dstore/QueryResults");
exports.Memory = _Memory;
exports.QueryResults = _QueryResults;
//  dgrid  ---
var _Grid = require("dgrid/Grid");
// import * as List from "dgrid/List";
var OnDemandGrid = require("dgrid/OnDemandGrid");
var Keyboard = require("dgrid/Keyboard");
var Selection = require("dgrid/Selection");
var ColumnResizer = require("dgrid/extensions/ColumnResizer");
var CompoundColumns = require("dgrid/extensions/CompoundColumns");
var nlsPagination = require("dgrid/extensions/nls/pagination");
//  Other ---
var gridHelper_1 = require("./gridHelper");
exports.Grid = declare("Grid", [OnDemandGrid, Keyboard, Selection, ColumnResizer, CompoundColumns, gridHelper_1.GridHelper]);
exports.Grid.prototype.i18nPagination = nlsPagination.root;
exports.PagingGrid = declare("PagingGrid", [_Grid, gridHelper_1.Pagination, Keyboard, Selection, ColumnResizer, CompoundColumns, gridHelper_1.GridHelper]);
exports.PagingGrid.prototype.i18nPagination = nlsPagination.root;
//# sourceMappingURL=index.js.map